import axios from 'axios';
import _get from 'lodash/get';

const requestURL = '/smarthelp/mmt-async-check';

// MMT service for page revoking
const unreadConversationChecker = () => (
  axios.get(requestURL)
    .then((response) => {
      if (_get(response, 'data.total_active_conversations') > 0) {
        return Promise.resolve({ available: true });
      }
      return Promise.resolve({ available: false });
    })
    .catch(() => Promise.reject({ available: false }))
);

module.exports = {
  unreadConversationChecker,
};
